export enum DashboardEventsOption {
    Summary,
    Chart
}
